var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-flex tw-gap-2"},[_c('CIcon',{class:_vm.colorClass,attrs:{"size":"20","icon":_vm.ciCheckCircle}}),_vm._v(" "),_c('div',{staticClass:"tw-text-base tw-text-grey-900"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }